export const features = [
  // ========================= //
  // BOOKING FORMS
  // ========================= //
  {
    icon: 'clipboard-check',
    name: 'Booking Forms',
    summary: 'Collect orders directly from customers online with configurable white-label booking forms.',
    title: 'Collect Orders Directly From Your Customers Effortlessly',
    lead: 'Streamline order collection with a branded online booking form. Easily configure the booking options to match your processes. Link to it directly or embed into your existing website.',
    image: '/images/features/booking-forms.png',
    sections: [
      {
        heading: 'Flexible and Configurable',
        body: 'Set up your booking form with settings, constraints and rules that match your operation.'
      },
      {
        heading: 'Make It Your Own',
        body: `Keep things consistent by applying your company's brand identity to the interface.`,
      },
      {
        heading: 'User-Friendly',
        body: 'Delight your customers with a booking form that is easy to use anywhere.'
      }
    ]
  },

  // ========================= //
  // CUSTOMER PORTAL
  // ========================= //
  {
    icon: 'portal-enter',
    name: 'Customer Portal',
    summary: 'Give customers access to their order history and address book via a branded portal.',
    title: 'Give Customers Access to their Own Management Dashboard',
    lead: 'Allow customers to create their own secure account, complete with their order history and personal address book, making it easy for them to re-order from you.',
    image: '/images/features/customer-portal.png',
    sections: [
      {
        heading: `Order History`,
        body: `Save time answering rudimentary questions by giving your customers access to their entire order history with your business.`
      },
      {
        heading: `Easy Repeat Orders`,
        body: `Convenience is key to getting repeat business from customers. With their own account, ordering again is easy.`
      },
      {
        heading: `Security Built-In`,
        body: `Privacy and security is crucial. We esnsure your customer's data is encrypted and secure.`
      }
    ]
  },

  // ========================= //
  // LIVE STATUS TRACKING
  // ========================= //
  {
    icon: 'location-circle',
    name: 'Live Status Tracking',
    title: 'Track the Status of an Order In Real Time',
    summary: 'Display the live status of their order from start to finish with a branded status page.',
    lead: 'Each order has a unique tracking link where customers can view the status of their order, or track it live on an interactive map once it is in progress.',
    image: '/images/features/status-tracking.png',
    sections: [
      {
        heading: `Address Validation`,
        body: `Give end-users the option to change their address on record if it's incorrect. Reduce missed or delayed orders due to the incorrect address.`
      },
      {
        heading: `Live Driver Tracking`,
        body: `Once an order is started, the customer will be notified with an ETA and a link to track the driver in real time on an interactive map.`
      },
      {
        heading: `After-Service Feedback`,
        body: `Get insight into your customer service levels with customer feedback on each order.`,
      }
    ]
  },

  // ========================= //
  // ORDER UPDATES
  // ========================= //
  {
    icon: 'bell-on',
    name: 'Order Updates',
    title: 'Send Order Updates As They Happen Automatically',
    summary: 'Send customers updates on their orders as they happen via phone or email.',
    lead: 'Manage expectations and reduce customer support overhead with automatic updates - like ETAs and PODs - sent to the relevant party throughout the lifecycle of an order.',
    image: '/images/features/order-notifications.png',
    sections: [
      {
        heading: `Order Status Updates`,
        body: `Keep customers updated and let them know when their order is confirmed, dispatched and completed.`,
      },
      {
        heading: `Accurate ETA Messages`,
        body: `Reduce turnaround times by sending an SMS with an estimated arrival time so customers can be ready for your driver when they arrive.`,
      },
      {
        heading: `Automated PODs`,
        body: `Automatically send a proof of delivery email to the original customer when an order is completed.`,
      }
    ]
  },

  // ========================= //
  // DRIVER APP
  // ========================= //
  // {
  //   icon: 'route',
  //   name: 'Optimised Routing',
  //   title: 'Complete More Orders in Less Time',
  //   summary: `Automatically plan the optimal routes for your drivers at the press of a button.`,
  //   lead: 'An AI-based system that continuously monitors your fleet telematics data and triggers actions and workflows based on your specific configuration settings.',
  //   image: '/images/features/monitoring.png',
  // },
  
  // ========================= //
  // DRIVER APP
  // ========================= //
  // {
  //   icon: 'mobile',
  //   name: 'Driver App',
  //   title: `Simplify Your Drivers' Jobs`,
  //   summary: `Give drivers the tools to receive, navigate to, and complete orders with their own app.`,
  //   lead: 'An AI-based system that continuously monitors your fleet telematics data and triggers actions and workflows based on your specific configuration settings.',
  //   image: '/images/features/monitoring.png',
  // },

  // ========================= //
  // FEDEREATED DELIVERY NETWORK
  // ========================= //
  // {
  //   icon: 'chart-network',
  //   name: 'Federated Delivery Network',
  //   title: 'Maximise Your Delivery Reach',
  //   summary: `Save time and money with 24/7 automated fleet monitoring based on your fleet's telematics.`,
  //   lead: 'An AI-based system that continuously monitors your fleet telematics data and triggers actions and workflows based on your specific configuration settings.',
  //   image: '/images/features/monitoring.png',
  // }
]